export const features = [
  {
    id: "scan",
    title: "Smart Document Scan",
    description:
      "Auto-detect document edges, correct perspective, and remove shadows instantly for crisp, professional scans every time.",
    icon: "ri-scan-line",
    color: "bg-[#E3F2FD]",
    iconColor: "text-[#4A90D9]",
  },
  {
    id: "filters",
    title: "AI Image Filters",
    description:
      "Choose from Original, Carbon, OCV Black, Sharp Pop, AI Color, and Magic Color to enhance your scanned documents.",
    icon: "ri-image-edit-line",
    color: "bg-[#E8F5E9]",
    iconColor: "text-[#4CAF50]",
  },
  {
    id: "ocr",
    title: "OCR Text Extraction",
    description:
      "Extract editable text from any scanned document or image with high-accuracy optical character recognition.",
    icon: "ri-text",
    color: "bg-[#F3E5F5]",
    iconColor: "text-[#7B1FA2]",
  },
  {
    id: "signature",
    title: "Digital Signature",
    description:
      "Sign documents electronically with your finger or stylus. Place signatures anywhere on the PDF with ease.",
    icon: "ri-edit-circle-line",
    color: "bg-[#FFF3E0]",
    iconColor: "text-[#F57C00]",
  },
  {
    id: "watermark",
    title: "Watermark",
    description:
      "Add custom text or image watermarks to protect your documents. Adjust opacity, size, and position freely.",
    icon: "ri-water-percent-line",
    color: "bg-[#E0F2F1]",
    iconColor: "text-[#00897B]",
  },
  {
    id: "qrcode",
    title: "QR Code",
    description:
      "Read and generate QR codes instantly. Embed QR codes into your PDFs for quick sharing and verification.",
    icon: "ri-qr-code-line",
    color: "bg-[#E8EAF6]",
    iconColor: "text-[#3F51B5]",
  },
  {
    id: "merge",
    title: "Merge & Split PDF",
    description:
      "Combine multiple documents into a single PDF or split large files into smaller, manageable pages.",
    icon: "ri-file-copy-line",
    color: "bg-[#FFFDE7]",
    iconColor: "text-[#F9A825]",
  },
  {
    id: "compress",
    title: "Compress PDF",
    description:
      "Reduce file size without losing quality. Share documents faster while keeping them perfectly readable.",
    icon: "ri-file-zip-line",
    color: "bg-[#FCE4EC]",
    iconColor: "text-[#C2185B]",
  },
  {
    id: "edit",
    title: "Advanced Text Editing",
    description:
      "Format text with bold, italic, underline, lists, and multiple fonts. Full rich-text control for annotations.",
    icon: "ri-font-color",
    color: "bg-[#EDE7F6]",
    iconColor: "text-[#512DA8]",
  },
];